import {
  Component, ChangeDetectionStrategy, Input, Output, ViewChild, TemplateRef, ElementRef,
  HostListener, OnInit, Injectable, OnChanges, EventEmitter
} from '@angular/core';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { I18n, CustomDatepickerI18n, NgbDateCustomParserFormatter, NgbDateNativeAdapter } from './injection-datepicker';
import { CommonService } from '../services/common.service';
import moment from 'moment';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-input-date',
    templateUrl: './input-date.component.html',
    styleUrls: ['./input-date.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }],
    standalone: false
})
export class InputDateComponent implements OnInit {
  @Input() placeholder;
  @Input() model;
  @Input() id;
  @Input() class;
  @Input() client;
  @Input() noteditable;
  @Input() showDatepicker;
  @Input() closeDatepickerOnSelect;
  @Input() disable;
  @Input() container;
  @Input() minDate;
  @Input() maxDate;
  @Input() position;
  @Input() inputDropdown;
  @Input() dateVide;
  @Input() readonly;
  @Input() activeDropUp;
  @Input() notclickOutside;
  @Input() activeNavigate;
  @Input() saisieManuel = false;
  @Input() changeMinMaxDate = false;
  @Input() visibleCondition = false;
  @Input() condition = false;
  @Output() changefct = new EventEmitter<any>();
  @Output() errorfct = new EventEmitter<any>();
  @Output() blurfct = new EventEmitter<any>();
  @Output() selectfct = new EventEmitter<any>();
  @Output() keyenterfct = new EventEmitter<any>();

  min: any = {};
  max: any = {};
  delay;

  inputSelected: any = {};
  isShowDate: Boolean = false;
  dropup: Boolean = false;
  isHasError: Boolean = false;

  @ViewChild('date') date;

  constructor(protected common: CommonService) {
  }

  ngOnInit() {
    if (!this.visibleCondition) {
      this.condition = true
    } else {
      this.condition = this.condition || false;
    }
    if (this.dateVide) {
      this.model = this.model || '';
    } else {
      this.model = this.model || new Date();
    }
    this.setMinMaxDate();
    this.inputSelected[this.id] = this.date;
    this.position = this.position || 'bottom-left';
    this.placeholder = this.placeholder || '';
  }

  setMinMaxDate() {
    if (this.minDate) {
      const date = new Date(this.minDate);
      this.min = {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
      };

      console.log(this.min)
    }
    if (this.maxDate) {
      const date = new Date(this.maxDate);
      this.max = {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
      };
    }
  }

  change($event) {
    const isdate = this.common.isDateCorrect($event);
    if (this.showDatepicker) {
      if (($event === '' || $event === null) && this.dateVide) {
        this.model = '';
        this.changefct.emit('');
      }
      if (isdate !== 'Date invalide') {
        if ($event === null && this.dateVide) {
          this.model = '';
          this.changefct.emit('');
        } else {
          const date = this.common.parseDate($event);
          this.model = new Date(date);
          this.changefct.emit(date);
          if (this.changeMinMaxDate) {
            this.setMinMaxDate();
          }
        }
      }
    } else {
      if (isdate !== 'Date invalide') {
        this.changefct.emit($event);
        if (this.changeMinMaxDate) {
          this.setMinMaxDate();
        }
      }

    }
  }

  changeDate($event) {
    clearTimeout(this.delay);
    const date = $event || '';
    const ctrl = this;
    let model;
    console.log('ctrl.saisieManuel : ' + ctrl.saisieManuel);
    this.delay = setTimeout(function () {
      if (date && typeof date === 'string') {
        const DDMMYYYY = date.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-\.](0?[1-9]|1[012])[\/\-\.]\d{4}$/) && moment(date, 'DD/MM/YYYY').isValid() ? true : false;
        if (DDMMYYYY) {
          model = moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY');
          if (model) {
            const dated = ctrl.common.parseDate(model);
            ctrl.model = new Date(dated);
            ctrl.change(ctrl.model)
          }
        } else {
          if (date && date.length === 6 && !ctrl.saisieManuel) {
            if (!date.includes('/') && moment(date, 'DDMMYY').isValid()) {
              model = moment(date, 'DDMMYY').format('DD/MM/YYYY');
              console.log(model, moment(date, 'DDMMYY').format('DD/MM/YYYY'));
              if (model) {
                const dated = ctrl.common.parseDate(model);
                ctrl.model = new Date(dated);
                ctrl.change(ctrl.model)
              }
            }
          } else {
            if (date && date.length === 8) {
              if (!date.includes('/') && moment(date, 'DDMMYYYY').isValid()) {
                model = moment(date, 'DDMMYYYY').format('DD/MM/YYYY');
                console.log(model, moment(date, 'DDMMYYYY').format('DD/MM/YYYY'))
                if (model) {
                  const dated = ctrl.common.parseDate(model);
                  ctrl.model = new Date(dated);
                  ctrl.change(ctrl.model)
                }
              } else if (moment(date, 'DD/MM/YY').isValid()) {
                model = moment(date, 'DD/MM/YY').format('DD/MM/YYYY');
                console.log(model, moment(date, 'DD/MM/YY').format('DD/MM/YYYY'))
                if (model) {
                  const dated = ctrl.common.parseDate(model);
                  ctrl.model = new Date(dated);
                  ctrl.change(ctrl.model)
                }
              }
            }
          }
        }
      } else {
        if (typeof date === 'object') {
          model = moment(date).format('DD/MM/YYYY');
          if (model) {
            const dated = ctrl.common.parseDate(model);
            ctrl.model = new Date(dated);
            ctrl.change(ctrl.model)
          }
        }
      }

      if ($event === null && ctrl.dateVide) {
        console.log('date empty', date);
        ctrl.model = '';
        ctrl.change('');
      }

      // if (model) {
      //     const dated = ctrl.common.parseDate(model);
      //     ctrl.model = new Date(dated);
      //     ctrl.change(ctrl.model)
      // } else {
      //     ctrl.change(ctrl.model)
      // }
      ctrl.isHasError = ctrl.error();
    }, (typeof date !== 'object' ? 600 : 0));
  }

  error() {
    this.errorfct.emit();
    return false;
  }

  focus(date) {
    if (this.showDatepicker) {
      const value = [date];
      /*if (this.common.inputTypeDate.length > 0) {
          this.common.inputTypeDate[0].close();
          value[0].ouvert = true;
          this.common.inputTypeDate = value;
      } else {
          value[0].ouvert = true;
          this.common.inputTypeDate = value;
      }*/
      if (!this.isShowDate) {
        this.isShowDate = true;
        this.common.inputTypeDate.forEach(elt => elt.close());
        this.common.inputTypeDate.push(date);
        date.ouvert = true;
        date.open();
        $('ngb-datepicker .bg-primary').focus();
      }

      if (this.activeNavigate) {
        date.navigateTo({ year: moment().format('YYYY') });
      }
      if (this.changeMinMaxDate) {
        this.setMinMaxDate();
      }
    }
  }

  formatDateOnMouseLeave() {
    const ctrl = this;
    const date = this.model;
    let model;
    if (date && typeof date === 'string') {
      const DDMMYYYY = date.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-\.](0?[1-9]|1[012])[\/\-\.]\d{4}$/) && moment(date, 'DD/MM/YYYY').isValid() ? true : false;
      if (DDMMYYYY) {
        model = moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY');
        if (model) {
          const dated = ctrl.common.parseDate(model);
          ctrl.model = new Date(dated);
          ctrl.change(ctrl.model)
        }
      } else {
        if (date && date.length === 6 && !ctrl.saisieManuel) {
          if (!date.includes('/') && moment(date, 'DDMMYY').isValid()) {
            model = moment(date, 'DDMMYY').format('DD/MM/YYYY');
            console.log(model, moment(date, 'DDMMYY').format('DD/MM/YYYY'));
            if (model) {
              const dated = ctrl.common.parseDate(model);
              ctrl.model = new Date(dated);
              ctrl.change(ctrl.model)
            }
          }
        } else {
          if (date && date.length === 8) {
            if (!date.includes('/') && moment(date, 'DDMMYYYY').isValid()) {
              model = moment(date, 'DDMMYYYY').format('DD/MM/YYYY');
              console.log(model, moment(date, 'DDMMYYYY').format('DD/MM/YYYY'))
              if (model) {
                const dated = ctrl.common.parseDate(model);
                ctrl.model = new Date(dated);
                ctrl.change(ctrl.model)
              }
            } else if (moment(date, 'DD/MM/YY').isValid()) {
              model = moment(date, 'DD/MM/YY').format('DD/MM/YYYY');
              console.log(model, moment(date, 'DD/MM/YY').format('DD/MM/YYYY'))
              if (model) {
                const dated = ctrl.common.parseDate(model);
                ctrl.model = new Date(dated);
                ctrl.change(ctrl.model)
              }
            }
          }
        }
      }
    } else {
      if (typeof date === 'object') {
        model = moment(date).format('DD/MM/YYYY');
        if (model) {
          const dated = ctrl.common.parseDate(model);
          ctrl.model = new Date(dated);
          ctrl.change(ctrl.model)
        }
      }
    }


    if (this.model === null && ctrl.dateVide) {
      console.log('date empty', date);
      ctrl.model = '';
      ctrl.change('');
    }
  }

  blur($event) {
    if (this.common.inputTypeDate && this.common.inputTypeDate.length > 0) {
      this.common.inputTypeDate[0].ouvert = false;
    }

    console.log('blur input date')
    if (!this.showDatepicker) {
      this.formatDateOnMouseLeave();
    }
    this.blurfct.emit($event);
  }

  selectDate($event) {
    if ($event) {
      if (typeof $event === 'object') {
        if ($event.day && $event.month && $event.year) {
          const date = `${$event.day}/${$event.month}/${$event.year}`;
          this.model = this.common.parseDate(date);
        }
      }
    }
    console.log(this.model, $event);
    this.common.clickElement('#' + this.id);
    if (this.closeDatepickerOnSelect) {
      this.common.inputTypeDate.forEach(elt => elt.close());
    }

    this.selectfct.emit($event);
  }

  keyenter($event) {
    const date = $event.target && $event.target.value ? $event.target.value : '';
    const ctrl = this;
    let model;

    if (date && typeof date === 'string') {
      const DDMMYYYY = date.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-\.](0?[1-9]|1[012])[\/\-\.]\d{4}$/) && moment(date, 'DD/MM/YYYY').isValid() ? true : false;
      if (DDMMYYYY) {
        model = moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY');
        if (model) {
          const dated = ctrl.common.parseDate(model);
          ctrl.model = new Date(dated);
          ctrl.change(ctrl.model)
        }
      } else {
        if (date && date.length === 6) {
          if (moment(date, 'DDMMYY').isValid()) {
            model = moment(date, 'DDMMYY').format('DD/MM/YYYY');
            console.log(model, moment(date, 'DDMMYY').format('DD/MM/YYYY'));
            if (model) {
              const dated = ctrl.common.parseDate(model);
              ctrl.model = new Date(dated);
              ctrl.change(ctrl.model)
            }
          }
        } else {
          if (date && date.length === 8) {
            if (moment(date, 'DDMMYYYY').isValid()) {
              model = moment(date, 'DDMMYYYY').format('DD/MM/YYYY');
              console.log(model, moment(date, 'DDMMYYYY').format('DD/MM/YYYY'))
              if (model) {
                const dated = ctrl.common.parseDate(model);
                ctrl.model = new Date(dated);
                ctrl.change(ctrl.model)
              }
            }
          }
        }
      }
    } else {
      if (typeof date === 'object') {
        model = moment(date).format('DD/MM/YYYY');
        if (model) {
          const dated = ctrl.common.parseDate(model);
          ctrl.model = new Date(dated);
          ctrl.change(ctrl.model)
        }
      }
    }

    if ($event === null && ctrl.dateVide) {
      console.log('date empty', date);
      ctrl.model = '';
      ctrl.change('');
    }


    this.keyenterfct.emit($event);
  }

  setFocuscalendar(event) {
    if (!this.container) {
      if (event.keyCode === 40 && event.target.nextElementSibling) {
        event.target.nextElementSibling.focus();
        return
      } else {
        this.keyUpDate(event);
      }
    } else {
      if (event.keyCode === 40 && event.target.nextElementSibling) {
        $('ngb-datepicker .bg-primary').click();
        return;
      } else {
        if (event.keyCode === 40) {
          $('ngb-datepicker .bg-primary').focus();
        } else {
          this.keyUpDate(event);
        }
      }
    }
  }

  clickOutsideDate($event) {
    const container = $('ngb-datepicker');
    if ($($event) && $($event)[0]) {
      const event = $($event)[0];
      // console.log(event.className)
      const isInput = event && (event.className && typeof event.className === 'string' &&
        (event.className || '').includes('input-date')) ? true : false;
      if (!isInput && container && !container.has(event).length) {
        this.blur($event);
        this.common.inputTypeDate.forEach(elt => elt.close());
        this.isShowDate = false;
      }
    }
  }

  keyUpDate(event) {
    // const specialKeys = [
    //     'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'
    // ];
    // if (specialKeys.indexOf(event.key) !== -1) {
    //     return;
    // }
    // const v = this.model;
    // if (v.match(/^(0[1-9]|1[0-2])$/) !== null) {
    //     this.model = v + '/';
    // } else if (v.match(/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])$/) !== null) {
    //     this.model = v + '/';
    // }


    // Do not use event.keycode this is deprecated.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
    // const current: string = event.target.value;
    // const next: string = current.concat(event.key);
    // console.log(next && !this.check(next));
    // if (next && !this.check(next)) {
    //     event.preventDefault();
    // }
  }

  getPosition(event) {
    const bottom = Math.abs($(window).height() - event.clientY);

    this.position = bottom < 250 && this.activeDropUp ? 'top-left' : this.position;
  }
}
